module.exports = __webpack_public_path__ + "img/profile3.ae9ba8ea.png";